import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import sanityFile from '../fragments/sanityFile.js';
var schema = defineObject('internationalizedArraySanityFileValue', {
    value: {
        title: 'Value',
        type: 'file'
    }
});
var validator = z.object({
    value: sanityFile.validator
}).partial();
schema.internationalizedArraySanityFileValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArraySanityFileValue.js.map